<template>
	<div id="systemmodule">
		<HrrBreadcrumb PMname="其他功能" CMname="广告信息管理" />
		<HrrMainLayout>
			<template slot="searh">
				<el-form :inline="true" :model="searchform">
					<el-form-item label="广告商名称：">
						<el-select v-model="searchform.advertiserId"   placeholder="请选择" filterable >
							<el-option 
							label="全部" 
							value=""></el-option>
							<el-option v-for="item in advertiser" 
							:key="item.advertiserId"
							:label="item.companyName" 
							:value="item.advertiserId">
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item >
						<el-input v-model="keyword" placeholder="关键字" >
							<el-select v-model="selectfield" slot="prepend" placeholder="请选择" class="input-with-select">
						      <el-option label="广告标题" value="adTitle"></el-option>
						      <el-option label="广告内容" value="adContent"></el-option>
							  <el-option label="广告描述" value="adDesc"></el-option>
							  <el-option label="安装人" value="installerName"></el-option>
						    </el-select>
						</el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="onSubmit">查询</el-button>
					</el-form-item>
				</el-form>
			</template>
			<template slot="buttons">
				<el-button-group>
					<el-button type="primary" icon="el-icon-edit" size="small" @click="Addclick" v-if="isHadFun('Add')">新增</el-button>
					<el-button type="primary" icon="el-icon-edit-outline" size="small" @click="editclick" v-if="isHadFun('Update')">编辑</el-button>
					<el-button type="primary" icon="el-icon-delete" size="small" @click="delclick" v-if="isHadFun('Delete')">删除</el-button>
					<el-button type="primary" icon="fa fa-check-square-o" size="small" v-if="false">审核</el-button>
				</el-button-group>
			</template>
			<template slot="table">
				<el-table  :data="tableData" ref="Opentable" @cell-click="cellclick" @selection-change="selectionchange"
				border 
				stripe 
				style="width: 100%" 
				v-loading="loading"  >
				<el-table-column type="selection" width="55" fixed="left">
				</el-table-column>
				<el-table-column prop="adId" label="序号" width="90" fixed="left" sortable>
				</el-table-column>
				<el-table-column prop="adTitle" label="广告标题" width="140" fixed="left"  >
				</el-table-column>
				<el-table-column prop="adContent" label="广告内容" width="250">
				</el-table-column>
				<el-table-column prop="adDesc" label="广告描述" width="250" >
				</el-table-column>
				<el-table-column  label="图片信息" width="250" >
					<template slot-scope="scope">            
                    <img :src="baseURL+scope.row.adPicUrl+'?r='+Math.random()"  min-width="70" height="70" />
                 </template>  
				</el-table-column>
				<el-table-column prop="adType" label="校验类型" width="150" >
				</el-table-column>
				<el-table-column prop="startDate" label="投放开始时间" width="160">
				</el-table-column>
				<el-table-column prop="endDate" label="投放结束时间" width="160">
				</el-table-column>
				<el-table-column prop="advertiserName" label="广告商名称" width="170">
				</el-table-column>
				<el-table-column prop="installerName" label="安装人" width="100" >
				</el-table-column>
				<el-table-column prop="installerTel" label="安装人联系方式" width="160">
				</el-table-column>
				<el-table-column prop="installerTime" label="预计安装时间" width="200">
				</el-table-column>
				<el-table-column prop="creationBy" label="创建人" width="100">
				</el-table-column>
				<el-table-column prop="creationDate" label="创建日期" width="200">
				</el-table-column>
				<el-table-column label="状态" width="100" align="center" fixed="right" >
                    <template slot-scope="scope">
                        <el-tag  :type="scope.row.status?'success':'danger'" disable-transitions>{{scope.row.status?'启用':'禁用'}}</el-tag>
                    </template>
                </el-table-column>
				<el-table-column label="操作" width="180" fixed="right">
					<template slot-scope="scope">
						<el-button @click.stop="Rowview(scope.row)" type="text" size="small" v-if="isHadFun('See')">查看</el-button>
						<el-button @click.stop="RowEdit(scope.row)" type="text"  size="small" v-if="isHadFun('Update')" >编辑</el-button>
						<el-button @click.stop="Rowdelete(scope.row)" type="text"  size="small" v-if="isHadFun('Delete')">删除</el-button>
						<el-button @click.stop="Bindcard(scope.row)" type="text"  size="small" v-if="isHadFun('Bindcard')">绑定设备</el-button>
					</template>
				</el-table-column>
			</el-table>
		</template>
		<template slot="Pagination">
			<!-- <HrrSearchformData :FormData=this.searchform @current-change="handleCurrentChange" /> -->
			<!-- <HrrSearchformData
			background
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:getform="searchform"
			:current-page="searchform.pageNum"
			:page-sizes="[5,11,15]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
			</HrrSearchformData> -->
			<el-pagination
			background
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="searchform.pageNum"
			:page-sizes="[5, 11, 15]"
			layout="total, sizes, prev, pager, next, jumper"
			:total="total">
		</el-pagination>
	</template>
</HrrMainLayout>
<!--弹窗-->
<el-dialog title="绑定卡片"  v-model="dialogVisible" :visible.sync="dialogVisible" :before-close="handleClose" class="el-dialog-resume">
    <el-tabs type="card" >
		<el-card class="educard" >
			<template>
				<el-form class="eduform" label-width="130px" :model="searchform" ref="searchform">
					<el-form-item label="卡号：" >
						<el-autocomplete
						class="inline-input"
						v-model="state"
						:fetch-suggestions="querySearch"
						placeholder="请输入内容"
						:trigger-on-focus="true"
						@select="handleSelect"
						></el-autocomplete>
					</el-form-item>
					<el-form-item label=" ">
						<el-button type="primary" @click="BindcardData()" >确定</el-button>
					</el-form-item>
				</el-form>
			</template>
		</el-card>
    </el-tabs>
</el-dialog>
</div>
</template>
<script>
	export default {
		name: 'AD_info',
		data(){
			return{
				searchform:{
					pageNum:1,
					pageSize:5,
					adTitle:"",
					advertiserId:"",
					adContent:"",
					adDesc:"",
					installerName:"",
					
				},
				advertiser:[],
				adLightBoxDefault:0,
				tableData:[],
				total:0,
				loading:true,
				dialogVisible:false,
				restaurants:[],
				state:"",
				BindCardAdid:"",
				selectionRows:[],
				selectfield:"adTitle",
				keyword:"",
				baseURL:this.$hrraxios.defaults.baseURL,
				admindata:[],
			}
		},
		methods:{
	     querySearch(queryString, cb) {
			//this.loadAll(queryString);
			var Vuethis=this;
			this.$hrraxios.get(this.$api.card.getSearch+queryString)
			.then(function (response) {
				var data=response.data;
				if(data.Success==true)
				{
					Vuethis.restaurants=data.Data;
					cb(Vuethis.restaurants);
				}else{
					Vuethis.$message.error(data.Prompt);
				}
			})
			.catch(function (error) {
				console.log(error);
			});
			// cb([{value:'text'}]);
		},
		handleSelect(item) {
			//console.log(item);
		},
		handleClose(done) {
			this.state=""
			done();
			// this.$confirm('确认关闭？')
			//   .then(_ => {
			//     done();
			//   })
			//   .catch(_ => {});
		},
		BindcardData(){
			var Vuethis=this;
			this.$hrraxios.post(this.$api.AD.postAndcard,{cardCode:this.state,AdId:this.BindCardAdid})
			.then((response)=>{
				var redata=response.data;
				if(redata.Success==true){
					Vuethis.$message({message:"绑定成功！",type:"success"});
					Vuethis.state=""
					Vuethis.dialogVisible=false;
				}else{
					Vuethis.$message({message:redata.Prompt,type:"error"});
				}
			})
	  	},
			onSubmit(){
				this.searchform.pageNum=1;
				this.searchform.adTitle="";
				this.searchform.adContent="";
				this.searchform.adDesc="";
				this.searchform.installerName="";
				this.searchform[this.selectfield]=this.keyword.trim();
				this.$route.meta.ADinfo=this.searchform
				this.initData();
			},
			handleSizeChange(val) {
				this.searchform.pageSize=val;
				this.initData();
			},
			handleCurrentChange(val) {
				this.searchform.pageNum=val;
				this.initData();
			},
			Rowview(val){
				this.$route.meta.row=val;
				this.$router.push({path:'/AD/info/view/'+val.adId});
			},
			Bindcard(val){
				//this.BindCardAdid=val.adId
				this.$route.meta.row=val;
				this.$router.push({path:'/AD/bindcard/'+val.adId});
				//this.dialogVisible=true;
			},
			RowEdit(val){
				this.$route.meta.row=val;
				this.$router.push({path:'/AD/info/edit/'+val.adId});
			},
			Rowdelete(val){

				this.$confirm("确定要删除 '"+val.adTitle+"' 此记录么？","删除提示",{type:"warning"})
				.then(()=>{
					var Vuethis=this;
					this.$hrraxios({
                        method: "delete",
                        url:this.$api.AD.DelAD+"/"+val.adId})
					.then((response)=>{
						var redata=response.data;
						if(redata.Success==true){
							Vuethis.$message({message:"删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							Vuethis.$message({message:redata.Prompt,type:"error"});
						}
					})
				}).catch((error)=>{
					console.log(error);
				});
			},
			Addclick(){
				this.$router.push({path:'/AD/info/add/',});
			},
			handleClick(tab, event) {
                console.log(tab, event);
            },
			pubclick(){
				if(this.selectionRows.length==0)
				{
					this.$message({message:"请先选择一行在操作",type:"warning"});
					return;
				}

			},
			editclick(){
				if(this.selectionRows.length==0)
				{
					this.$message({message:"请先选择一行在操作",type:"warning"});
					return;
				}
				if(this.selectionRows.length>1)
				{
					this.$message({message:"只能操作一行数据",type:"warning"});
					return;
				}
				this.$route.meta.row=this.selectionRows[0];
				this.$router.push({path:'/AD/info/edit/'+this.selectionRows[0].adId});
			},
			delclick(){
				if(this.selectionRows.length<1)
				{
					this.$message({message:"请先选择一行在删除",type:"warning"});
					return;
				}
				this.$confirm("确定要删除这些记录么？",{type:"warning"})
				.then(()=>{
					var loading = this.$loading({
						lock: true,
						text: '删除中...',
						spinner: 'el-icon-loading',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					var Vuethis=this;
					var PostfunArr=[];
					this.selectionRows.forEach(myrow=>{
						var postRe=this.$hrraxios({
                        method: "delete",
                        url:this.$api.AD.DelAD+"/"+myrow.adId})
						PostfunArr.push(postRe);
					});
					this.$axios.all(PostfunArr)
					.then(this.$axios.spread(function(){
						loading.close();
						//console.log(arguments);
						var isalldel=true;
						for(var i=0;i<arguments.length;i++){
							if(arguments[i].data.Success==false)
							{
								isalldel=false;
							}
						}
						if(isalldel==true){
							Vuethis.$message({message:"全部删除成功！",type:"success"});
							Vuethis.initData();
						}else{
							//有删除失败的未处理
						}
					}));
				})
				.catch((error)=>{
					
				});
			},
			cellclick(row, column, cell, event){
				this.$refs.Opentable.toggleRowSelection(row);
			},
			selectionchange(selection){
				this.selectionRows=selection;
			},
			initData(){
				var Vuethis=this;
				this.loading=true;
				this.$hrraxios.get(this.$api.AD.getAD, {params:this.searchform})
				.then(function (response) {
					Vuethis.loading=false;
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.tableData=data.Data.List;
						Vuethis.total=data.Data.Total;
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					Vuethis.loading=false;
					console.log(error);
				});
			},
			advertiserData(){
				var Vuethis=this;
				this.$hrraxios.get(this.$api.AD.getAdvertiser)
				.then(function (response) {
					var data=response.data;
					if(data.Success==true)
					{
						Vuethis.advertiser=data.Data;
					}else{
						Vuethis.$message.error(data.Prompt);
					}
				})
				.catch(function (error) {
					console.log(error);
				});
			},
		},
		beforeRouteLeave(to, from, next) {
			// 导航离开该组件的对应路由时调用
			to.meta.row=from.meta.row;
			to.meta.ADinfo=from.meta.ADinfo;
			next();
		},
		created(){
			// if(this.$route.params.id){
			// this.SiteId2.push(parseInt(this.$route.params.id));
			// }
			this.$common.getFunListByMCode(this,"ADInfo",()=>{
				if(this.$route.meta.ADinfo !=undefined){
					var searchformData=this.$route.meta.ADinfo
					this.searchform.pageNum=searchformData.pageNum;
					this.searchform.pageSize=searchformData.pageSize;
					if(searchformData.advertiserId!=""){
						this.searchform.advertiserId=searchformData.advertiserId;
					}
					if(searchformData.adTitle!=""){
						this.selectfield="adTitle";
						this.keyword=searchformData.adTitle;
						this.searchform.adTitle=searchformData.adTitle;
					}
					if(searchformData.adContent!=""){
						this.selectfield="adContent";
						this.keyword=searchformData.adContent;
						this.searchform.adContent=searchformData.adContent;
					}
					if(searchformData.adDesc!=""){
						this.selectfield="adDesc";
						this.keyword=searchformData.adDesc;
						this.searchform.adDesc=searchformData.adDesc;
					}
					if(searchformData.installerName!=""){
						this.selectfield="installerName";
						this.keyword=searchformData.installerName;
						this.searchform.installerName=searchformData.installerName;
					}
				}
				this.initData();
				this.advertiserData();
			});
		}
	}
</script>
<style >
  .input-with-select { width: 110px;}
	.educard label {color: #99a9bf;}
	.educard{margin-bottom: 10px;}
	.utable .el-button,.utable .el-button+.el-button{margin-right: 10px;margin-left: 0;}
  #lightForm .el-select{width: 100px;}
</style>
